import { FilterPanel } from '@statsbomb/kitbag-global-football';
import { EventAttributeFilters } from '../filters/EventAttributeFilters';
import { PitchFiltersContent } from '../filters/PitchFilters';
import { DataLockerHighLevelFilters } from './filters/DataLockerHighLevelFilters';

export const EventsFilters = () => (
  <FilterPanel>
    <DataLockerHighLevelFilters />
    <EventAttributeFilters />
    <PitchFiltersContent />
  </FilterPanel>
);
